import { Chart } from 'primereact/chart';
import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { ApiGet } from '../../helper/API/ApiData';
import { handleError } from '../../utils/helper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';

const MobilizationDashboard = ({ showChart = true }: { showChart?: boolean }) => {

    const navigate = useNavigate()

    const [totalCount, setTotalCount] = useState({
        "totalLocationCount": 0,
        "totalSelectedCount": 0
    });
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});
    const [datatableData, setDatatableData] = useState([])

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);

        ApiGet(`member/dashboard`)
            .then((res: any) => {
                if (res?.status === 200) {
                    setTotalCount({
                        "totalLocationCount": res.data[0].totalLocationCount,
                        "totalSelectedCount": res.data[0].totalSelectedCount
                    })
                    const labelList: string[] = []
                    const dataList: number[] = []
                    res.data[0].memberChartData.forEach((item: { count: number, location: string }) => {
                        dataList.push(item.count)
                        labelList.push(item.location)
                    })

                    const pieChartData = {
                        labels: labelList,
                        datasets: [
                            {
                                data: dataList,
                                backgroundColor: [
                                    documentStyle.getPropertyValue('--blue-500'),
                                    documentStyle.getPropertyValue('--yellow-500'),
                                    documentStyle.getPropertyValue('--green-500')
                                ],
                                hoverBackgroundColor: [
                                    documentStyle.getPropertyValue('--blue-400'),
                                    documentStyle.getPropertyValue('--yellow-400'),
                                    documentStyle.getPropertyValue('--green-400')
                                ]
                            }
                        ]
                    }

                    const options = {
                        plugins: {
                            legend: {
                                position: 'right',
                                padding: 10,
                                labels: {
                                    font: {
                                        size: 14,
                                        family: 'Arial',
                                        color: '#333' // custom color
                                    }
                                }
                            }
                        }
                    };

                    setChartData(pieChartData);
                    setChartOptions(options);
                    setDatatableData(res.data[0].locationDatatable.map((item: any, index: number) => ({
                        ...item,
                        serial: index + 1
                    })))
                }
            })
            .catch((error) => {
                handleError(error)
                return error
            })

    }, [])


    const gotoMobilization = () => {
        navigate('/shgadmin/member')
    }


    return (
        <Container fluid className="p-3">
            <h4 className="page-title">Mobilization Details</h4>
            <Row>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoMobilization()}>
                        <Card.Body style={{ backgroundColor: '#609ea2' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-globe" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Cities</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalSelectedCount}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoMobilization()}>
                        <Card.Body style={{ backgroundColor: '#28a745' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-home" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of villages</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalLocationCount}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card style={{ cursor: "pointer" }} onClick={() => gotoMobilization()}>
                        <Card.Body style={{ backgroundColor: '#141E46' }}>
                            <Row>
                                <Col md={5} className='d-flex justify-content-center align-items-center'>
                                    <i className="pi pi-users" style={{ fontSize: '2.5rem', color: '#fff' }}></i>
                                </Col>
                                <Col md={7} style={{ color: '#fff' }}>
                                    <div>
                                        <p className="mb-2" style={{ color: '#fff' }}>No of Individuals Mobilized</p>
                                        <h4 className="mb-0 card-title">{totalCount.totalSelectedCount}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </ Card.Body>
                    </Card>
                </Col>

            </Row>
            {showChart &&
                <Row className='mt-4 d-flex justify-content-between'>
                    <Col md={6}>
                        <Card style={{}}>
                            <Card.Header>
                                <Card.Title>Cities Statistics</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Chart
                                    type="pie"
                                    data={chartData}
                                    options={{
                                        ...chartOptions, legend: {
                                            position: 'left'
                                        }
                                    }}
                                    style={{
                                        width: "90%",
                                        height: 400,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                    className=""
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card style={{}}>
                            <Card.Header>
                                <Card.Title>Area wise Beneficiary Statistics</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col md={12} style={{
                                        height: 400
                                    }}>
                                        {/* Table */}
                                        <DataTable
                                            dataKey="id"
                                            value={datatableData}
                                            showGridlines={false}
                                            stripedRows
                                            style={{
                                                borderWidth: 1,
                                                borderColor: '#59d05d',
                                                border: '1px solid #59d05d'
                                            }}
                                            paginator
                                            rows={4}
                                            tableStyle={{
                                            }}>
                                            <Column headerStyle={{ backgroundColor: '#59d05d', }} header="" field="serial"></Column>
                                            <Column headerStyle={{ backgroundColor: '#59d05d', color: '#fff', }} field="location" header="Locality"></Column>
                                            <Column headerStyle={{ backgroundColor: '#59d05d', color: '#fff', }} field="count" header="Total Population"></Column>
                                        </DataTable>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }
        </Container>
    )
}

export default MobilizationDashboard